<template>
    <div>
        <h1>Contatos de interesse</h1>
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="list-group">
                        <div  class="list-group-item" :key="index" v-for="(item,index) in content"> 
                            <div class="d-flex w-100 justify-content-between">
                                <h4 class="mb-1">{{item.nome}}</h4>
                                <small>{{item.tsData}}</small>
                            </div>
                            <p class="mb-1 small">{{item.email}} / {{item.telefone}}</p>
                            <p class="mb-1">Segmento: <b>{{item.servicos.segmentos.titulo}}</b></p>
                            <p class="mb-1">Serviço: <b>{{item.servicos.titulo}}</b></p>
                            <button class="btn btn-danger" @click="fnAtiva(item.contatoId,item.nome,item.ativo)">DELETAR</button>
                        </div>
                         <div  class="list-group-item text-center" v-if="content.length == 0"> 
                            <p class="mb-1 small">Nenhum registro encontrado</p>
                        </div>

                    </div>                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { getData,deleteData } from "../global/utils";

    export default {
        data: function () {
            return {
            stripe: true,
            colorAlert: "primary",
            titleAlert: "",
            segmentoId: "",
            activeAlert: false,
            content: [],
            iconArea: 50 * 1,
            errors: [],
            erro: "",
            urlApi: "autoespecialistas",
            carregando: true,
            deleteId: "",
            deleteAtivo: null,
            deleteTitulo: "",
            };
        },

        mounted() {
            this.fnCarregaItems();
        },
        methods: {
            async fnCarregaItems() {
            let data = await getData(
                this.urlApi + "/servicosform"
            );
            console.log(data);
            this.content = data[0].content;
            this.carregando = false;
            this.$vs.loading.close();
            },
            fnAtiva(valueId, valueTitle, valueAtivo) {
            this.deleteId = valueId;
            this.deleteTitulo = valueTitle;
            this.deleteAtivo = valueAtivo
            this.$vs.dialog({
                color: this.colorAlert,
                acceptText: 'Continuar',
                title: this.deleteAtivo ? "Deseja deletar o item " + valueTitle + "?" : "Deseja ativar o item "  + valueTitle + "?",
                text: this.deleteAtivo ? "O item não será exibido em algumas aplicações" : "O item será exibido normalmente nas aplicações",
                accept: this.fn_delete,
            });
            },
            async fn_delete() {
            await deleteData(this.urlApi+"/servicosform/ativa/", this.deleteId, "custoFixoId" ,this.deleteAtivo );
            this.fnCarregaItems();
            this.deleteAtivo = null
            },

        }        
    }
</script>

<style lang="scss" scoped>

</style>